module.exports = __webpack_public_path__ + "static/evgnosia-2e2154b1c59af0a78cfc72dda010dbe8.jpg";